import { RequestType } from './request-type.enum';

export const statusParams = {
  [RequestType.ACCEPTED]: 'Approved',
  [RequestType.REJECTED]: 'Rejected',
  [RequestType.PENDING]: 'InAcceptance'
};
